<template>
    <div class="productList_single">
        <div class="vkfhikf">
            <div class="title">{{ $t('other.a241') }}</div>
            <!-- <div class="store_header">
               <div style="width:80px;">产品类型：</div>
               <div class="pomog">
                <span :class="{'btn':true,'active':distribution == item.value}" v-for="(item,index) in distributionType" :key="index" @click="handle(item,0)">{{item.label}}</span>
               </div>
          </div> -->
            <div class="store_header">
                <div style="width:80px;">{{ $t('other.a242') }}</div>
                <div class="pomog">
                    <span :class="{ 'btn': true, 'active': component == item.value }" v-for="(item, index) in productType"
                        :key="index" @click="handle(item, 1)">{{ item.label }}</span>
                </div>
            </div>
            <div class="store_header">
                <div style="width:80px;">{{ $t('other.a243') }}</div>
                <div class="pomog">
                    <span :class="{ 'btn': true, 'active': storeId == btn.storeId }" v-for="(btn, index) in storeOptions"
                        :key="index" @click="handle(btn, 2)">{{ btn.storeName }}</span>
                </div>
            </div>
            <div class="store_header">
                <div style="width:80px;">{{ $t('other.a244') }}</div>
                <div class="pomog">
                    <el-select size="mini" style="width:160px;margin-right:3px;" v-model="value"
                        :placeholder="$t('other.a50')">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input size="mini" style="width:250px;" v-model="input" :placeholder="$t('other.a244')"
                        clearable></el-input>
                    <el-button size="mini" style="margin-left:5px" type="info"
                        @click="search()">{{ $t('other.a245') }}</el-button>
                </div>
            </div>
            <div class="store_header" style="justify-content: space-between">
                <span class="gowuarea">
                    {{ $t('other.a246') }}
                    <i class="iconfont icon-gouwuche"></i>
                    <span class="inglj">{{ checkedList.length }}</span>

                </span>
                <span>
                    <el-button size="mini" type="danger" @click="confrim()">{{ $t('other.a166') }}</el-button>
                    <el-button size="mini" style="margin-right:20px;" type="info"
                        @click="backTo()">{{ $t('other.a146') }}</el-button>
                </span>
            </div>
        </div>

        <div v-if="!overDataList.length" class="nodata">{{ $t('other.a247') }}</div>
        <div v-else>
            <div class="ojki" v-for="(item, index) in overDataList" :key="index">
                <div class="bvnj">
                    <span style="margin-right:30px;">{{ $t('other.a248') }}{{ item.storeName }}</span>
                    <span>{{ $t('other.a249') }}{{ item.itemSku }}</span>
                </div>
                <div>
                    <div class="pokl" v-for="(children, index02) in item.storeItems" :key="index02">
                        <span style="margin:0 20px;">
                            <el-checkbox @change="checkOrder(children, index, index02)"
                                v-model="children.checked"></el-checkbox>
                        </span>
                        <span class="yuio"><img :src="children.image" /></span>
                        <span class="kloi">sku：{{ children.skuName }}</span>
                        <span class="kloi">{{ $t('other.a226') }}{{ children.cusCode }}</span>
                        <span class="kloi">{{ $t('other.a250') }}{{ children.stock }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="Pager">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[15, 20, 30, 100]" :page-size="dataParams.offset"
                layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
            </el-pagination>
        </div>


    </div>
</template>

<script>
import utils from '../../utils/utils'
import { showLoading, hideLoading } from '../../assets/js/loading.js'
import userStoreItemsApi from '../../api/moudles/userStoreItems'
import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
    data() {
        return {
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            storeOptions: [],
            targetIndex: [],
            listErrorOptions: [],
            component: true,
            showErrorDeleteItem: false,
            distribution: false,
            storeId: null,
            productType: [{
                label: this.$t('other.a251'),
                value: true,
            }, {
                label: this.$t('other.a252'),
                value: false,
            }],
            distributionType: [{
                label: this.$t('other.a253'),
                value: false,
            }, {
                label: this.$t('other.a254'),
                value: true,
            }],
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            options: [{
                label: this.$t('other.a255'),
                value: 1,
            }, {
                label: this.$t('other.a256'),
                value: 2,
            }, {
                label: this.$t('other.a257'),
                value: 3,
            },],
            value: 3,
            currentPage: null,
            dataParams: {
                distribution: false,//true为分销产品，false,为普通产品
                component: true,//ture为单品，false,为套餐
                cusCode: null,
                offset: 100,
                page: 0,
                sellerId: null,
                storeId: null,
                userId: JSON.parse(localStorage.getItem('userInfo')).userId
            },
            pageTotal: 0,
            input: null,
            overDataList: [],
            checked: false,
            activeIndex: -1,
            vipLevel: JSON.parse(localStorage.getItem('userInfo')).vipLevel,
            showProduct: false,
            showshopOption: false,
            input10: null,
            openQueHuochuankao: false,
            storeData: {},
            outOfstockReminderAmont: 0,
            outOfstockReminder: [],
            remindData: [],
            sluginreminder: false,
            unsalable: [],
            unsalableData: {},
            transproductDia: false,
            targetStoreid: null,
            getDataList: [],
            indexTbb: null,
            checkedList: [],
            singleChooseType: null


        }
    },

    components: {
        QrcodeDialog
    },
    computed: {
        ...mapState({
            mygoodslist: state => state.mygoods.mygoodslist,
            userId: state => state.shopaccess.userInfo.userId,
            userStormList: state => state.userStoreItems.userStormList,
            itemsCount: state => state.userStoreItems.itemsCount,
            deleTip: state => state.userStoreItems.deleTip,
            deletSuccess: state => state.userStoreItems.deletSuccess,
            getDateSuccess: state => state.userStoreItems.getDateSuccess,
            xuehuoInfo: state => state.userStoreItems.xuehuoInfo,
            xuehuoInfocount: state => state.userStoreItems.xuehuoInfocount,
            secondPassword: state => state.shopaccess.secondPassword,
            newUserstoreItem: state => state.userStoreItems.newUserstoreItem,
            refresh: state => state.userStoreItems.refresh,
            slugInReminder: state => state.userStoreItems.slugInReminder,
            unsalable: state => state.userStoreItems.unsalable,

        }),



        num() {
            let num = 0
            if (this.overDataList) {
                num = this.overDataList.length
            }
            return num
        },
    },
    watch: {
        storeId() {

            this.dataParams.page = 0
            this.dataParams.storeId = this.storeId
            this.getOverseaData()

        },
        checked() {
            if (this.checked) {
                this.overDataList.forEach(p => {
                    p.checked = true
                })
            } else {
                this.overDataList.forEach(p => {
                    p.checked = false
                })
            }
        },
        input() {
            if (!this.input) {
                this.dataParams.cusCode = null
                this.getOverseaData()
            }
        },
    },
    created() {
        this.init()

    },
    methods: {

        ...mapActions('userStoreItems', [
            'getStockRemind',
        ]),
        ...mapMutations('userStoreItems', [
            'TARGET_ALL',
            'GET_DATA_STATUS_COLSE',
            'KEEP_CHOOSED_ITEM',
            'SET_REPLENISHMENT_PREIOD',
            'GET_UNSALABLE_DATA',
        ]),

        singleChoose() {
            console.log(this.singleChooseType)
        },

        confrim() {
            let list = []
            this.checkedList.forEach(p => {
                let otherData = p.itemKey?p.itemKey:'DXS|' + p.cusCode
                list.push({
                    image: p.image,
                    itemName: p.groupName,
                    itemSku: p.itemSku,
                    variationSku: p.skuName,
                    variationQuantityPurchased: 1,
                    variationId: null,
                    other: otherData,
                    itemKey: 'DXS|' + p.cusCode,
                    packageHeight: p.packageHeight,
                    packageLength: p.packageLength,
                    packageWidth: p.packageWidth,
                    weight: p.weight,
                    orderId: null,
                    storeId: p.storeId,
                    variationName: p.variationName,
                    variationsCopy: p.storeItemsTwo.map(item => {
                        return {
                            itemKey: 'DXS|' + item.cusCode,
                            variationSku: item.skuName,
                            variationName: item.variationName,
                            image: item.image

                        }
                    })

                })
            })

            utils.updateInfoByCache({
                cacheKey: 'addOrderItem',
                userId: this.userId,
                cacheData: JSON.stringify(list)
            })

            this.$router.push({
                path: '/changeOrderInfo',
                query: {
                    area: this.$route.query.area,
                    type: 'success',
                    changeType: this.$route.query.changeType > 0 ? this.$route.query.changeType : null,
                    quantity: this.$route.query.quantity > 0 ? this.$route.query.quantity : null
                }
            })

            console.log(list)
        },




        checkOrder(children, index, index02) {
            if (this.$route.query.changeType == 1) {
                this.overDataList.forEach(p => {
                    p.storeItems.forEach(i => {
                        i.checked = false
                    })
                })
                children.checked = true
                this.checkedList = [children]
            } else {
                if (children.checked) {
                    this.checkedList.push(children)
                } else {
                    let num = this.checkedList.findIndex(item => item.cusCode == children.cusCode)
                    this.checkedList[num] = null
                }

                let list = this.checkedList.filter(p => {
                    if (p !== null) {
                        return p
                    }
                })

                this.checkedList = list
            }
            console.log(this.checkedList)
            console.log(list)
        },
        backTo() {
            this.$router.push({
                path: '/changeOrderInfo',
                query: {
                    area: this.$route.query.area
                }
            })
        },
        search() {
            if (!this.input) {
                return
            }
            this.dataParams.cusCode = this.input.trim()
            this.getOverseaData()
        },
        init() {
            let stores = JSON.parse(localStorage.getItem('userInfo')).stores
            if (stores) {
                //筛选所有启用的海外仓
                for (let i = 0; i < stores.length; i++) {
                    if (stores[i].storeType !== 4 && stores[i].isUsed) {
                        this.storeOptions.push(stores[i])
                    }
                }

                if (!this.storeOptions.length) {
                    this.$message.warning(this.$t('other.a258'))
                    return
                } else {
                    let id = utils.defaultStoreId(this.storeOptions)
                    this.storeId = id ? id : this.storeOptions[0].storeId

                    console.log(this.storeOptions, id)
                }
            } else {
                this.$message.warning(this.$t('other.a259'))
            }

        },
        handle(item, index) {
            this.checkedList = []
            console.log(item, index);
            if (index == 0) {
                this.distribution = item.value
                this.dataParams.distribution = this.distribution
                this.getOverseaData()
            }

            if (index == 1) {
                this.component = item.value
                this.dataParams.component = this.component
                this.getOverseaData()
            }

            if (index == 2) {
                this.storeId = item.storeId
                utils.setDefalultStoreId(this.storeId)
            }




            console.log(this.dataParams)
        },

        //获取海外仓的库存产品
        getOverseaData() {
            showLoading()
            userStoreItemsApi
                .getStoreItem(this.dataParams)
                .then(res => {
                    if (res.code === 200) {

                        res.data.groups.forEach(p => {
                            p.itemSku = p.itemSku ? p.itemSku : this.$t('other.a260')
                            p.createTime = utils.renderTime(p.createTime)
                            p.storeName = utils.showstoreNameBystoreId(p.storeId)
                            p.checked = false
                            p.totalNum = 0
                            p.storeItemsCopy = []

                            let target = this.dataParams.cusCode
                            p.storeItems.forEach(i => {
                                if (target && (utils.matchStoreDesc(target, i.skuName) || target == i.cusCode)) {
                                    p.storeItemsCopy.push(i)
                                }
                                i.storeItemsTwo = p.storeItems
                                i.groupName = p.groupName
                                i.checked = false
                                p.totalNum += i.storeNum
                            })


                            p.storeItems = p.storeItemsCopy.length > 0 ? p.storeItemsCopy : p.storeItems
                        })

                        this.overDataList = res.data.groups
                        this.pageTotal = res.data.count
                        console.log('海外仓库数据', this.overDataList)

                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.dataParams.offset = parseInt(`${val}`)
            this.handleCurrentChange()
        },
        //显示当前第几页
        handleCurrentChange(val) {
            this.currentPage = parseInt(`${val}`)
            this.dataParams.page = `${val}` == 'undefined' ? 0 : (parseInt(`${val}`) - 1) * this.dataParams.offset
            this.getOverseaData()
        },

    }
}

</script>
<style lang='scss' scoped>
/deep/ .el-dropdown-menu__item {
    font-size: 22px;
    line-height: 45px;
    padding: 2px 15px;
    border-bottom: 1px solid #eee;
}


.productList_single {
    background: #eee;
    min-height: 100vh;
    position: relative;


    .ojki {
        background-color: #fff;
        box-sizing: border-box;
        padding: 3px 7px;
        margin: 10px;

        .bvnj {
            padding: 5px 10px;
            border-bottom: 1px solid #eee;
        }

        .pokl {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #eee;
            margin: 2px 3px;


            .kloi {
                flex: 1;
            }
        }


        .yuio {

            display: inline-block;
            width: 50px;
            height: 50px;
            overflow: hidden;
            border: 1px dashed #eee;
            margin: 0 10px;

            img {
                width: 100%;
            }
        }
    }





    .ovjknfk {
        cursor: pointer;
    }


    .Pager {
        position: fixed;
        bottom: 0;
        left: 205px;
        right: 0;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        text-align: right;
    }

    .nodata {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        font-size: 20px;
        margin-top: 200px;
    }

    .lvinf {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 3px 8px
    }

    .createTime {
        font-size: 10px;
    }


    .title {
        font-size: 18px;
        font-weight: 400;
        ;
        margin-bottom: 20px;

    }

    .vkfhikf {
        background-color: #fff;
        // position: fixed;
        // right: 0;
        // left: 205px;
        // z-index: 79;
        // top: 50px;
    }

    .weconkf {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;

        .menu {
            margin-right: 10px;
            margin-left: 0px;
        }
    }

    .store_header {
        margin: 10px 0;
        background: #fff;
        padding-bottom: 7px;
        display: flex;

        .gowuarea {
            margin-left: 20px;
            display: inline-block;
            box-sizing: border-box;
            padding: 8px 5px;
            border: 1px solid #F56C6C;
            border-radius: 3px;
            position: relative;
            cursor: pointer;

            .inglj {
                position: absolute;
                display: inline-block;
                right: 9px;
                top: 2px;
                min-width: 18px;
                min-height: 18px;
                text-align: center;
                font-size: 10px;
                line-height: 18px;
                color: #ffffff;
                border-radius: 50%;
                background-color: red;
            }
        }

        .icon-gouwuche {
            color: rgb(255, 92, 10);
            margin-right: 20px;
            padding: 10px 5px;
        }

        .pomog {
            display: flex;
            flex-wrap: wrap;
            flex: 1;

        }


        .btn {
            border: 1px solid #d9d9d9;
            box-sizing: border-box;
            padding: 3px 2px;
            margin-right: 3px;
            margin-bottom: 5px;
            cursor: pointer;
            line-height: 20px;
            border-radius: 3px;
        }

        .active {
            color: #fff;
            background: #409eff;
        }
    }


    .overseaProduct_list {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 50px;
        // padding-top: 140px;



        .overseaProduct_item {
            box-sizing: border-box;
            padding: 3px;
            margin: 8px 6px;
            background-color: #fff;
            border-radius: 5px;
            border: 1px solid #fff;


        }

        .overseaProduct_item_active {
            border: 1px solid #F56C6C;

        }

        .update_overseaProduct {

            text-align: right;
            margin: 7px 0;

            .btn {
                background-color: rgb(42, 165, 21);
                border-radius: 3px;
                padding: 4px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: bold;
                cursor: pointer;
            }

            .btn_reverse {
                background-color: #F56C6C;
                border-radius: 3px;
                padding: 4px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: bold;
                cursor: pointer;
            }
        }




        .pic_box {
            width: 173px;
            height: 173px;
            overflow: hidden;
            border-radius: 5px;
            cursor: pointer;
        }

        .title_overseaProduct {
            // width:148px;
            // height: 1.7rem;
            // -webkit-line-clamp: 2;
            // text-overflow: ellipsis;
            // overflow: hidden;
            // font-size: 12px;
            // box-sizing: border-box;
            // padding: 0 0 0 6px;

            font-size: 12px;
            width: 148px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            min-height: 33px;

        }

        .item_desc {
            width: 148px;
            height: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            padding: 5px 0 5px 6px;
        }

        .item_desc_parentsku {
            color: #F56C6C;
            width: 148px;
            height: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            padding: 5px 0 5px 6px;
            white-space: nowrap;

        }
    }



}
</style>